import React, { useMemo } from "react";
import * as S from "./CmpDateSelection.style";
import SelectorForm from "../selectorForm";
import { useTranslation } from "react-i18next";

// pipes
import * as P from "../../../../../../../utils/pipes";

// Components
import { PopUpPayload } from "../genericTemplate/GenericTemplate.style";
import Popup from "reactjs-popup";
import FlorenzInputDate from "../../../../../../florenzComponents/florenzInputDate";
import ZaiaInput from "../../../../../../zaiaComponents/zaiaInput";

function CmpDateSelection({
  item,
  insertfunction,
  customFormChangeItem,
  typeView
}) {  
  const { t, i18n: { language } } = useTranslation("global");  

  const applyTimezoneOffset = (dateValue) => {
    if (!(dateValue instanceof Date)) return dateValue;
    const userTimezoneOffset = dateValue.getTimezoneOffset() * 60000;
    return new Date(dateValue.getTime() + userTimezoneOffset);
  };

  const changeOptionItem = (value) => {
    const valueDate = new Date(value);
    const adjustedDate = applyTimezoneOffset(valueDate);
    const userToCustomFormField = {
      customFormFieldParentId: item?.customFormFieldParentId,
      customFormFieldId: item.id,
      value: adjustedDate,
      key: adjustedDate
    }
    insertfunction(userToCustomFormField);
  }
  
  const normalizeDateValue = (dateItem) => {
    if (!dateItem) return null;
    return dateItem.value || new Date(Date.now());
  };

  const displayValue = useMemo(() => {
    const rawDate = normalizeDateValue(customFormChangeItem);
    return rawDate ? P.formatNumberDateInput(rawDate) : "";
  }, [customFormChangeItem]);

  console.log(displayValue);
  

  return (
    <S.CmpDateSelection>
      <div className="selection-container">
        <div className="title">
          <div className="title__text">
            {item.fieldName && P.dataTranslation(item.fieldName, language)}
          </div>
          {
            !displayValue &&
            <div className="title__required warning">
              {!item.optional && "*"}
            </div>
          }
          {
            displayValue && <i className="title__icon icon zaia-i-check-1"></i>
          }
          <Popup
            trigger={
              <i className="title__icon-payload icon zaia-alert"></i>
            }
            on={['hover', 'focus']}
            closeOnDocumentClick
            keepTooltipInside
            position={['right center']}
            nested
          >
            <PopUpPayload>
              <p>
              {P.dataTranslation(item.descript, language)}
              </p>
            </PopUpPayload>
          </Popup>
        </div>
        <div className="input-container">
          <FlorenzInputDate
            label={t("globally.date")}
            value={displayValue}
            getText={changeOptionItem}
            type="date"
            disabled={typeView === 'view'}
            required={!item.optional}
          />
        </div>
      </div>
    </S.CmpDateSelection>
  );
}

export default CmpDateSelection;
